var irreducible = require('./irreducible');
var isObject = require('./isObject');

module.exports = irreducible('Object', isObject);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Object.js
 ** module id = 1553
 ** module chunks = 0
 **/